"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const styles_1 = require("@material-ui/core/styles");
const Alert_1 = __importDefault(require("@material-ui/lab/Alert"));
const Collapse_1 = __importDefault(require("@material-ui/core/Collapse"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const useStyles = styles_1.makeStyles((theme) => ({
    root: {
        borderRadius: '4px',
        padding: '4px 12px !important',
        alignItems: 'center',
        minHeight: 'auto !important',
        '& .MuiAlert-message': {
            padding: '0 !important',
            margin: '0 !important',
            lineHeight: '1.2 !important',
        },
        '& .MuiAlert-icon': {
            marginRight: '8px !important',
            padding: '0 !important',
            marginTop: '0 !important',
            marginBottom: '0 !important',
        },
    },
    standardInfo: {
        border: 'none !important',
        backgroundColor: '#E3F2FD !important',
    },
    standardSuccess: {
        border: 'none !important',
        backgroundColor: '#E8F5E9 !important',
    },
    standardError: {
        border: 'none !important',
        backgroundColor: '#FFEBEE !important',
    },
    standardWarning: {
        border: 'none !important',
        backgroundColor: '#FFF3E0 !important',
    },
}));
const ReviewAlert = (props) => {
    const { isVisible, severity, alertTitle, alertMessage, onClose } = props;
    const [visible, setIsVisible] = react_1.useState(isVisible);
    const classes = useStyles();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Collapse_1.default, { in: visible },
            react_1.default.createElement(Alert_1.default, { classes: {
                    root: classes.root,
                    standardInfo: classes.standardInfo,
                    standardSuccess: classes.standardSuccess,
                    standardError: classes.standardError,
                    standardWarning: classes.standardWarning,
                }, severity: severity, onClose: () => {
                    setIsVisible(false);
                    if (onClose)
                        onClose();
                } },
                react_1.default.createElement(Typography_1.default, { variant: "body2", style: { fontSize: '12px', margin: 0, padding: 0, lineHeight: '1.2' } }, alertTitle),
                alertMessage))));
};
ReviewAlert.propTypes = {
    isVisible: prop_types_1.default.bool,
    severity: prop_types_1.default.string.isRequired,
    alertTitle: prop_types_1.default.string.isRequired,
    alertMessage: prop_types_1.default.any.isRequired,
    onClose: prop_types_1.default.any,
};
exports.default = ReviewAlert;
